import { createGlobalState } from "react-hooks-global-state"

const { useGlobalState, setGlobalState } = createGlobalState({
  userCookies: null,
  // printername: null,
})

export { useGlobalState, setGlobalState }
